import { Box, Icon, Text } from '@oneloop/jopijs';
import PickerWithInput from '.';
import styles from './styles.module.scss';

function LinkPicker({ editor, handleDropdown }) {
  const handleCloseLinkPicker = () => {
    handleDropdown({ open: false });
  };

  const handlePressEscape = (event) => {
    if (event.key === 'Escape') {
      event.stopPropagation();
      handleCloseLinkPicker();
    }
  };

  const handleSubmit = (link) => {
    const href = link;
    const emptySelection = editor.view.state.selection.empty;
    const BLANK_SPACE = ' ';

    if (emptySelection) {
      editor
        .chain()
        .focus()
        .extendMarkRange('link')
        .setLink({ href })
        .command(({ tr }) => {
          tr.insertText(href);
          return true;
        })
        .run();
    } else {
      editor.chain().focus().toggleLink({ href }).run();
    }

    const initialSelectionPos = editor.state.selection.$anchor.pos;
    const endSelectionPos = editor.state.selection.$head.pos;
    const forwardestPosition = Math.max(initialSelectionPos, endSelectionPos);

    editor.chain().focus().setTextSelection(forwardestPosition).run();
    editor.chain().focus().insertContent(BLANK_SPACE).run();

    handleCloseLinkPicker();
  };

  return (
    <Box className={styles.container} onKeyDown={handlePressEscape}>
      <Box className={styles.header}>
        <Text className={styles.title}>Add link</Text>
        <Icon
          icon="icon-cerrar"
          fontSize="12px"
          onClick={handleCloseLinkPicker}
          className={styles['close-icon']}
        />
      </Box>

      <PickerWithInput
        placeholder="Paste link here"
        onSubmit={handleSubmit}
        onCancel={handleCloseLinkPicker}
        ctaText="Save"
        styles={{ maxWidth: '250px' }}
      />
    </Box>
  );
}

export default LinkPicker;
